<template>
    <div class="questionnaire-container step-container step-width row visible-on">
        <div class="questionnaire-step">
            <div v-for="(singleStep, index) in steps" :key="index" class="single-step">
                <!-- 当前进度主题图片 -->
                <div class="top-image-div"><span :class="['icon top-image', ...getProgressIconClassNames(singleStep)]" :style="getStepIcon(index)"></span></div>
                <!-- 当前进度状态图片 -->
                <div class="center-image-div"><span :ref="`step${index}`" :class="['icon iconfont center-image', getProgressIcon(index)['address']]" :style="getStepIcon(index)"></span></div>
                <!-- <div class="center-image-div"><img :ref="`step${index}`" :src="getProgressIcon(index)" :class="[steps[index]['order'] > currentStep ? 'unfinished-img' : '']" alt=""></div> -->
                <!-- 当前进度主题标题 -->
                <div class="step-title" :title="getText(singleStep['title'])">{{ getText(singleStep['title']) }}</div>
            </div>
        </div>
        <div class="step-line step-top" :style="{ width: stepLineWidth }"></div>
    </div>
</template>
<script>
import { questionnaireMixin } from '@/components/questionnaire/form/mixin.js'

// @steps: the whole steps content, including title and icon of each step.
// @currentStep: the currentStep index. (From one not zero)
// @progressIcons: the icons that show the steps progress.
// @defaultColor: to set up icon and processIcon color

export default {
  mixins: [questionnaireMixin],
  props: ['steps', 'currentStep', 'progressIcons', 'defaultColor'],
  data () {
    return {
      stepLineWidth: '82%'
    }
  },
  mounted () {
    this.setLine()
  },
  methods: {
    setLine () {
      const stepCount = this.steps.length
      const leftRect = this.$refs.step0[0].getBoundingClientRect()
      const rightRect = this.$refs[`step${stepCount - 1}`][0].getBoundingClientRect()
      this.stepLineWidth = `${rightRect.right - leftRect.left}px`
    },
    getStepIcon (index) {
      const single = this.steps[index]
      let currentColor = single.icon.color
      if (!currentColor) {
        currentColor = this.defaultColor
      }
      if (this.currentStep > single.order) {
        currentColor = '#707070'
      }
      if (this.currentStep < single.order) {
        currentColor = '#cdcdcd'
      }
      return `color: ${currentColor}`
    },
    getProgressIconClassNames (singleStep) {
      const classNames = singleStep.icon.address
      if (classNames && classNames.startsWith('el-')) {
        return [classNames]
      } else {
        return ['iconfont', classNames]
      }
    },
    getProgressIcon (index) {
      let iconIndex = 'currentIcon'
      const single = this.steps[index]
      if (this.currentStep > single.order) {
        iconIndex = 'finishedIcon'
      }
      if (this.currentStep < single.order) {
        iconIndex = 'unfinishedIcon'
      }
      return this.progressIcons[iconIndex]
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '~@/assets/iconfont/iconfont.css';
.step-container {
    width: 95%;
    min-height: 120px;
    height: auto;
    text-align: center;
    margin: 0 auto;
    padding-bottom: 18px;
    position: relative;
    .questionnaire-step {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
        .single-step {
            flex: 1 1 0;
            min-width: 0;
            padding: 0 8px;
            display: flex;
            flex-direction: column;
            align-items: center;
            z-index: 100;

            div {
                min-height: 20px;
                line-height: 20px;
                text-align: center;
                z-index: 100;
                color: gray;
                margin-bottom: 10px;
            }
            .top-image-div {
                span {
                    font-size: 24px;
                }
                .top-image[class*=onboarding-icon-] {
                  display: inline-block;
                  speak: none;
                  text-transform: none;
                  font-family: onboardingiconfont !important;
                  font-style: normal;
                  font-weight: 400;
                  font-variant: normal;
                  -webkit-font-smoothing: antialiased;
                  -moz-osx-font-smoothing: grayscale;
                }
            }
            .center-image-div {
                span {
                    font-size: 20px;
                }
                .center-image::before {
                    background-color: white;
                }
                // img {
                //     width: 20px;
                //     height: 20px;
                //     z-index: 100;
                // }
                // .unfinished-img {
                //     width: 12px;
                //     height: 12px;
                //     z-index: 100;
                // }
            }
            .step-title {
                text-align: center;
                user-select: none;
                font-size: small;
                width: 100%;
                line-height: 18px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            // .line {
            //     width: 100%;
            //     height: 3px;
            //     background-color: gray;
            //     position: relative;
            //     top: -70px;
            //     left: 0%;
            //     z-index: 99;
            // }
            // .progress-icon:after {
            //     content: '';
            //     width: 100%;
            //     height: 2px;
            //     background-color: #019875;
            //     left: 50%;
            //     position: absolute;
            //     z-index: 99;
            // }

            // .progress-icon.active:before,
            // .progress-icon.active:after {
            //     background-color: #019875;
            // }
        }
    }
    .step-line {
        margin: 0 auto;
        height: 2px;
        border-radius: 4px;
        background-color: gray;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: 99;
    }
    .step-top {
      top: 52px;
    }
}
/* 超小型设备 */
@media (max-width: 767px) {

}

/* 小型设备（平板电脑，768px 起） */
@media (min-width: 768px) {
    .single-step {
        padding: 0 12px !important;
    }
    .step-container {
        width: 45% !important;
    }
}
</style>
